module.exports = __webpack_public_path__ + "assets/a4c61466b3a4ebc3788456795a35384d.png";